import { UpdateAccountAccessRequestBody } from "@syla/shared/types/requests/UpdateAccountAccessRequestBody";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function updateAccountAccess(
  accountId: string,
  props: UpdateAccountAccessRequestBody,
): Promise<void> {
  try {
    const { data } = await axios.patch(`/accounts/${accountId}/access`, props);
    return data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
